<template>
  <div>
    <div
      class="box"
      :style="
        schoolCode == '10013' || schoolCode == '10541' || schoolCode == '12981'
          ? 'padding: 0 20px 49px'
          : 'padding: 16px 15px 54px'
      "
    >
      <Header v-if="schoolCode == '14197'" type="1" title=""></Header>
      <p v-if="schoolCode != '10013'" class="box-title">
        <i @click="backApp()" v-if="!isNeedLogout"></i>{{ heardName }}
      </p>
      <div
        v-if="schoolCode == '10013'"
        :class="userType == '0' ? 'box-imgS box-img' : 'box-imgT box-img'"
      >
        <span>北邮微教学</span>
      </div>
      <div
        v-else-if="schoolCode == '14197'"
        style="opacity:0.5"
        :class="userType == '0' ? 'box-imgS box-img' : 'box-imgT box-img'"
      >
        <span style="line-height:35px;padding-top:20px;opacity:1">
          <em style="font-size:18px;font-style:normal">湖北工程职院</em>
          <br />
          教务系统手机端
        </span>
      </div>
      <!-- userType == '0' ? 'box-imgS box-img' : 'box-imgT box-img' -->
      <div
        v-else
        :class="schoolCode == '10541' ? 'boximg box-img' : 'boximg3 box-img'"
      >
        <span>欢迎使用教务管理系统</span>
      </div>
      <van-collapse
        v-model="activeNames"
        class="box-content"
        v-for="(menu, index1) of menuList"
        :key="index1"
      >
        <van-collapse-item
          :title="menu.name"
          :name="menu.i_id"
          v-if="menu.child.length > 0"
          :icon="menu.icon"
        >
          <van-grid :column-num="menuNub" v-if="schoolCode != '13954'">
            <van-grid-item
              v-for="(item, index2) of menu.child"
              :key="index2"
              @click="goMenu(item)"
            >
              <span
                v-if="item.icon && item.icon.class"
                :class="item.icon.class"
                :style="item.icon.style"
              ></span>
              <div v-else-if="item.name == '常见问题解决方案'">
                <img
                  style="width: 42px;height: 42px; margin-top: 8px"
                  :src="item.icon"
                  alt=""
                />
              </div>
              <span
                v-else
                class="iconfont iconshouye9"
                style="color:#FF8080"
              ></span>
              <span
                class="item-value"
                :style="item.name == '常见问题解决方案' ? nameStyle : ''"
                >{{ item.name }}</span
              >
            </van-grid-item>
          </van-grid>

          <van-grid :column-num="menuNub" v-else>
            <van-grid-item
              v-for="(item, index2) of menu.child"
              :key="index2"
              @click="goMenu(item)"
            >
              <van-badge v-if="item.name == '课程表' && istk == '1'" dot>
                <div>
                  <div style="text-align: center;line-height: 45px;">
                    <span
                      v-if="item.icon && item.icon.class"
                      :class="item.icon.class"
                      :style="item.icon.style"
                    ></span>
                  </div>
                  <div class="name">{{ item.name }}</div>
                </div>
              </van-badge>
              <van-badge v-else>
                <div>
                  <div style="text-align: center;line-height: 45px;">
                    <span
                      v-if="item.icon && item.icon.class"
                      :class="item.icon.class"
                      :style="item.icon.style"
                    ></span>
                  </div>
                  <div class="name">{{ item.name }}</div>
                </div>
              </van-badge>
            </van-grid-item>
          </van-grid>
        </van-collapse-item>
      </van-collapse>
      <van-dialog
        v-model="show_shsj"
        class="my-Dialog"
        title="社会实践学分预警"
        :show-confirm-button="ms === 0"
        :confirm="colse"
      >
        <div class="yjtittle">同学，你好！</div>
        <div class="yjcontext">
          根据培养方案根据培养方案根据培养方案根据培养方案根据培养方案根据培养方案根据培养方案根据培养方案。。。。。。
        </div>
        <p @click="show_shsj = false">我已知悉</p>
      </van-dialog>

      <van-dialog
        v-model="ldandshsjObj.show_shsj"
        class="my-Dialog"
        title="社会实践学分预警"
        :show-confirm-button="ms === 0"
        :confirm="colse"
      >
        <div class="yjtittle">同学，你好！</div>
        <div class="yjcontext" v-html="ldandshsjObj.message_shsj"></div>
        <p @click="ldandshsjObj.show_shsj = false">我已知悉</p>
      </van-dialog>

      <van-dialog
        v-model="ldandshsjObj.show_ldjy"
        class="my-Dialog"
        title="劳动教育教育学时预警"
        :show-confirm-button="ms === 0"
        :confirm="colse"
      >
        <div class="yjtittle">同学，你好！</div>
        <div class="yjcontext" v-html="ldandshsjObj.message_ldjy"></div>
        <p @click="ldandshsjObj.show_ldjy = false">我已知悉</p>
      </van-dialog>
    </div>
    <van-dialog
      class="my-dialog"
      v-model="isShowTips"
      :showConfirmButton="false"
    >
      <div class="msg-box">
        <div class="msg-title">提示</div>
        <div class="msg-text">{{ msgText }}</div>
        <div class="btn-bar">
          <div class="btn plain" @click="isShowTips = false">关闭</div>
          <div class="btn" @click="onDialogConfirm">评价</div>
        </div>
      </div>
    </van-dialog>

    <van-dialog
      class="my-dialog"
      v-model="isShowXyyj"
      :showConfirmButton="false"
    >
      <div class="msg-box">
        <div class="msg-text">您有新的学业完成情况警示通知,请<span style="color: red;font-size: 20px;">务必</span>登录教务系统进行确认,否则须自行承担一切后果!</div>
      </div>
    </van-dialog>

  </div>
</template>

<script>
import { Api } from "@/utils/axios";

import Vue from "vue";
import { Collapse, CollapseItem } from "vant";
import { Grid, GridItem } from "vant";

Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Collapse);
Vue.use(CollapseItem);
export default {
  data() {
    return {
      isShowXyyj:false,
      show_shsj: false,
      show_ldjy: false,
      message: "",
      ldandshsjObj: {
        show_shsj: false,
        message_shsj: "",
        show_ldjy: false,
        message_ldjy: ""
      },
      heardName: "工具箱",
      menuNub: 3,
      ms: 5000,
      activeNames: [],
      menuList: [],
      itemList: [],
      userType: false,
      i_id: "",
      resetList: [],
      Identity:
        sessionStorage.getItem("Identity") ||
        JSON.parse(sessionStorage.getItem("userInfo")).userType,
      isNeedLogout: sessionStorage.getItem("isNeedLogout"),
      istk: "",
      nameStyle: "margin-top: 5px;",
      teacherList: [
        // 武汉科技大学-教师信息查看
        {
          name: "考务安排申请",
          path: "/kwapsq/index",
          url:'js_kwapsq',
          icon: { class: "iconfont iconshouye6", style: "color:#865FC1" }
        },
         // 武汉科技大学-教师信息查看
         {
          name: "教师信息查看",
          path: "/jsjbxx/index",
          url:'js_jbxxxg',
          icon: { class: "iconfont iconshouye6", style: "color:#865FC1" }
        },
        // 重庆电子-我的教学安排
        {
          name: "我的教学安排",
          path: "/jsjxap/index",
          url: "js_wdjxap",
          icon: { class: "iconfont iconshouye6", style: "color:#865FC1" }
        },
        // 重庆电子-我的监考
        {
          name: "我的监考",
          path: "/jsjkcx/index",
          url: "js_wdjk",
          icon: { class: "iconfont iconshouye16", style: "color:#FF8080" }
        },
        // 重庆电子-课程考试安排查询
        {
          name: "课程考试安排查询",
          path: "/jskcksap/index",
          url: "js_kcksapcx",
          icon: { class: "iconfont iconshouye16", style: "color:#FF8080" }
        },
        // 学科竞赛填报
        {
          name: "学科竞赛填报",
          path: "/xkjstb/index",
          url: "xkjstb",
          icon: { class: "iconfont iconshouye1", style: "color:#865FC1" }
        },
        // 选课状态查看
        {
          name: "选课状态查看",
          path: "/xkztck/index",
          url: "xkztck",
          icon: { class: "iconfont iconshouye16", style: "color:#FF8080" }
        },
        // 学籍异动审核
        {
          name: "学籍异动审核",
          path: "/xjydsh/index",
          url: "ydsh",
          icon: { class: "iconfont iconshouye12", style: "color:#865FC1" }
        },
        // 选课名单查看
        {
          name: "选课名单查看",
          path: "/xkmdck/jxapgl",
          url: "jxapgl",
          icon: { class: "iconfont iconshouye6", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/sksjsqsh/index",
          url: "js_sh_sksjsq",
          icon: { class: "iconfont iconshouye5", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/sksjqrsh/index",
          url: "js_sh_sksjqr",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "劳动任务审核",
          path: "/workTaskPass/index",
          url: "js_ldrwsh",
          icon: { class: "iconfont iconshouye9", style: "color:#865FC1" }
        },
        {
          name: "班级成绩查询",
          path: "/grade/search/search",
          url: "js_jsbjcj",
          icon: { class: "iconfont iconshouye9", style: "color:#865FC1" }
        },
        {
          name: "实训考勤",
          path: "/practiceKQ/index",
          url: "js_sxkq",
          icon: { class: "iconfont iconshouye9", style: "color:#865FC1" }
        },
        {
          name: "任务发布",
          path: "/taskAdd/index",
          url: "js_rwfb",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "学生名单查询",
          path: "/studentInfo/index",
          url: "js_xsmdcx",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "个人调课",
          path: "/personalTable/index",
          url: "js_grtk",
          icon: { class: "iconshouye14 iconfont", style: "color:#865FC1" }
        },
        {
          name: "教室借用申请",
          path: "/brrow10008/index",
          url: "js_jsjygl",
          icon: { class: "iconshouye1 iconfont", style: "color:#FFC327" }
        },
        {
          name: "教学学风评测",
          path: "/evaluateIndex",
          url: "js_jxpj_jxxfpc",
          icon: { class: "iconshouye1 iconfont", style: "color:#FFC327" }
        },
        {
          name: "成绩录入审核",
          path: "/pass/passIndex",
          url: "js_sh_cj",
          icon: { class: "iconshouye14 iconfont", style: "color:#865FC1" }
        },
        {
          name: "教材使用评价",
          path: "/nod?title=教材使用评价",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "教学通知",
          path: "/jxzx/index?title=教学通知",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "教学制度",
          path: "/jxzx/index?title=教学制度",
          icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        },
        {
          name: "教学新闻",
          path: "/jxzx/index?title=教学新闻",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "我的课程",
          path: "/classTest/index?title=我的课程",
          icon: { class: "iconfont iconshouye18", style: "color:#FFC327" }
        },
        {
          name: "课程作业",
          path: "/classTest/index?title=课程作业",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "课程测验",
          path: "/classTest/index?title=课程测验",
          icon: { class: "iconshouye9 iconfont", style: "color:#00C897" }
        },
        {
          name: "课程讨论",
          path: "/classTest/index?title=课程讨论",
          icon: { class: "iconshouye21 iconfont", style: "color:#865FC1" }
        },
        {
          name: "学生缓考审核",
          path: "/teacher/bookIndex?id=6",
          url: "js_sh_xshk",
          icon: { class: "iconshouye9 iconfont", style: "color:#00C897" }
        },
        {
          name: "成绩查卷审核",
          path: "/teacher/bookIndex?id=8",
          url: "js_sh_cjcj",
          icon: { class: "iconshouye12 iconfont", style: "color:#FF8080" }
        },
        {
          name: "成绩录入审核",
          path: "/pass/passIndex?path=/new/Home",
          icon: { class: "iconshouye14 iconfont", style: "color:#865FC1" }
        },
        {
          name: "成绩修改审核",
          path: "/teacher/bookIndex?id=10",
          url: "js_sh_cjxg",
          icon: { class: "iconshouye21 iconfont", style: "color:#865FC1" }
        },
        {
          name: "调课审核",
          path: "/teacher/examine/adjustList?path=/new/Home",
          url: "js_sh_tk",
          icon: { class: "iconshouye10 iconfont", style: "color:#5E73FF" }
        },
        {
          name: "教室借用审核",
          path: "/teacher/examine/borrowingList?path=/pass/index",
          url: "js_sh_js",
          icon: { class: "iconshouye25 iconfont", style: "color:#865FC1" }
        },
        {
          name: "学生竞赛审核",
          path: "/xsjssh/index",
          url: "js_sh_xsjjsh",
          icon: { class: "iconshouye10 iconfont", style: "color:#5E73FF" }
        },
        {
          name: "补打修改考勤审核",
          path: "/teacher/examine/bdkqshList",
          url: "js_bdxgjqsh",
          icon: { class: "iconshouye21 iconfont", style: "color:#865FC1" }
        },
        {
          name: "监考查询",
          path: "/invigilate",
          url: "js_jkcx",
          icon: { class: "iconfont iconshouye1", style: "color:#FFC327" }
        },
        {
          name: "学生成绩查询",
          path: "/studentCjxx",
          url: "js_xscjcx",
          cicon: { class: "iconfont iconshouye1", style: "color:#FFC327" }
        },
        {
          name: "监考调代",
          path: "/teacher/examSearch",
          url: "js_kw_jktd",
          icon: { class: "iconfont iconshouye2", style: "color:#5E73FF" }
        },
        {
          name: "随堂考试",
          path: "/teacher/classList",
          url: "js_kw_stks",
          icon: { class: "iconfont iconshouye3", style: "color:#865FC1" }
        },
        {
          name: "非考试周考试申请",
          path: "/teacher/classList",
          icon: { class: "iconfont iconshouye3", style: "color:#865FC1" }
        },
        {
          name: "考场信息查询",
          path: "/teacher/examRoom",
          url: "js_kw_kcxxcx",
          icon: { class: "iconfont iconshouye4", style: "color:#5E73FF" }
        },
        {
          name: "教学评价",
          path: "/evaluate",
          url: "js_jxpj",
          icon: { class: "iconfont iconshouye4", style: "color:#5E73FF" }
        },
        {
          name: "评价结果查询",
          path: "/pjjgcx/pjjgcxQuery",
          url: "js_jxpj",
          cicon: { class: "iconfont iconshouye1", style: "color:#FFC327" }
        },
        // {
        //   name: "教学评价",
        //   path: "/evaluate",
        //   url: "js_jxpj_jxpj",
        //   icon: { class: "iconfont iconshouye4", style: "color:#5E73FF" }
        // },
        {
          name: "评价结果查看",
          path: "/evaluationResults/index",
          url: "js_jxpjjg",
          icon: { class: "iconfont iconshouye8", style: "color:#865FC1" }
        },
        {
          name: "工作量查询",
          path: "/workNum/index",
          url: "js_jxpj_gzlcx",
          icon: { class: "iconfont iconshouye13", style: "color:#5E73FF" }
        },
        {
          name: "教学学风测评",
          path: "/teacher/learnHome",
          icon: { class: "iconfont iconshouye5", style: "color:#00C998" }
        },
        {
          name: "成绩修改",
          path: "/grade/update/index",
          url: "/teacher/getCjxgxx",
          icon: { class: "iconfont iconshouye14", style: "color:#865FC1" }
        },
        {
          name: "成绩查询",
          path: "/grade/search/index",
          icon: { class: "iconfont iconchengjichaxun2", style: "color:#865FC1" }
        },
        {
          name: "培养方案总纲",
          path: "/train/indpyfazgIndexex",
          url: "js_pyfa_zg",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "专业培养方案",
          path: "/train/commonIndex",
          url: "js_pyfa_zy",
          icon: { class: "iconfont iconshouye7", style: "color:#865FC1" }
        },
        {
          name: "专业教学进程",
          path: "/train/teachingProcess",
          url: "js_pyfa_zyjxjc",
          icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        },
        {
          name: "教学计划 ",
          path: "/train/teachingPlan",
          url: "js_pyfa_jxjh",
          icon: { class: "iconfont iconshouye9", style: "color:#00C998" }
        },
        {
          name: "学生选题情况",
          path: "selected",
          url: "js_bysj_xsxt",
          icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        },
        {
          name: "调课申请",
          path: "/exchangeK/index",
          url: "js_tksq",
          icon: { class: "iconfont iconshouye10", style: "color:#5E73FF" }
        },
        {
          name: "调课申请记录",
          path: "/exchangeK/historList",
          icon: { class: "iconfont iconshouye10", style: "color:#5E73FF" }
        },
        {
          name: "教材",
          path: "/teacher/textbook",
          url: "js_jc",
          icon: { class: "iconfont iconshouye11", style: "color:#FF8080" }
        },
        {
          name: "卓越计划",
          path: "/teacher/zyjhDkxz",
          url: "js_zyjh",
          icon: { class: "iconfont iconshouye11", style: "color:#FF8080" }
        },
        {
          name: "教室借用",
          path: "/bindex",
          url: "js_jsjy",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "教室借用记录",
          path: "/roomBorrow/historyList",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "考勤",
          path: "/teacher/attendance",
          url: "js_kq",
          icon: { class: "iconfont iconshouye23", style: "color:#865FC1" }
        },
        {
          name: "课程表",
          path: "/surfaces",
          url: "js_kcb",
          icon: { class: "iconfont iconshouye17", style: "color:#00C998" }
        },
        {
          name: "实验课表",
          path: "/SyKbTable",
          url: "js_sykcb",
          icon: { class: "iconfont iconshouye17", style: "color:#FF8080" }
        },
        {
          name: "实践课程表",
          path: "/practiceSurfaces",
          url: "js_sjkcb",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "我的课堂",
          path: "/teacher/create",
          url: "js_wdkt",
          icon: { class: "iconfont iconshouye19", style: "color:#FFC327" }
        },
        {
          name: "班级课表",
          // path: "/teacher/searchCondition?id=0",
          path: "/classTable/index",
          url: "js_bjkb",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "教师课表查询",
          path: "/teacher/searchCondition?id=1",
          url: "js_jiaoskcbcx",
          icon: { class: "iconfont iconshouye21", style: "color:#00C998" }
        },
        // {
        //   name: "课程课表",
        //   path: "/teacher/searchCondition?id=2",
        //   icon: { class: "iconfont iconshouye17", style: "color:#00C998" }
        // },
        // {
        //   name: "教室课表",
        //   path: "/teacher/searchCondition?id=3",
        //   icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        // },
        {
          name: "审核",
          path: "/pass/index",
          url: "js_kxjs",
          icon: { class: "iconfont iconshouye18", style: "color:#FFC327" }
        },
        {
          name: "毕业设计",
          path: "/design",
          url: "js_bysj",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "毕业设计查看",
          path: "/design_msg",
          url: "js_bysjck",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "空闲教室",
          path: "/restRooms/index",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "今日空闲教室",
          path: "/restClassroom",
          url: "js_jrkxjs",
          icon: { class: "iconfont iconshouye25", style: "color:#00C897" }
        },
        {
          name: "学生信息查询",
          path: "/informationService/index",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "",
          path: "/examSchedule",
          url: "js_ksapcx",
          icon: { class: "iconfont iconshouye25", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/ksapcx/index",
          url: "js_kw_ksapcx",
          icon: { class: "iconfont iconshouye25", style: "color:#5E73FF" }
        },
        {
          name: "学生评价统计",
          path: "/evaluateSum/index",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "通知",
          path: "/new/Msg",
          icon: { class: "iconfont iconshouye18", style: "color:#FF8080" }
        },
        {
          name: "顶岗实习",
          path: "/internshipTeacher/index",
          url: "js_dgsx",
          icon: { class: "iconfont iconshixiqiandao", style: "color:#FF8080" }
        },
        {
          name: "教学课程查询",
          path: "/teacher/jxkccx",
          url: "js_jxkcb",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "各类课表查询",
          path: "/teacher/surfaAll",
          url: "js_kb_all",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "课表查询(教师)",
          path: "/teacher/surCuseAll_Find?findType=0&singcont=1",
          url: "js_kb_all_skls",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "课表查询(班级)",
          path: "/teacher/surCuseAll_Find?findType=1&singcont=1",
          url: "js_kb_all_skbj",
          icon: { class: "iconfont iconshouye17", style: "color:#FF8282" }
        },
        {
          name: "课表查询(课程)",
          path: "/teacher/surCuseAll_Find?findType=2&singcont=1",
          url: "js_kb_all_skkc",
          icon: { class: "iconfont iconshouye17", style: "color:#EE7BFF" }
        },
        {
          name: "课表查询(教室)",
          path: "/teacher/surCuseAll_Find?findType=3&singcont=1",
          code: "js_kb_all_skdd",
          icon: {
            class: "iconfont iconshouye17",
            style: "color:rgba(118,107,255,.7)"
          }
        },
        {
          name: "巡考查询",
          path: "/teacher/js_xkcx",
          url: "js_kw_xkcx",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "成绩录入查询",
          path: "/teacher/scoreEntry",
          code: "js_cjllcx",
          icon: { class: "iconfont iconshouye18", style: "color:#EE7BFF" }
        },
        {
          name: "教师缓考审核",
          path: "/teacher/jshksh",
          url: "js_jshksh",
          icon: { class: "iconshouye9 iconfont", style: "color:#5E73FF" }
        },
        {
          name: "质量平台",
          path: "/zlpt",
          url: "js_zlpt",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        },
        {
          name: "教学进度管理",
          path: "/teacher/jxjdgl",
          url: "js_jiaoxjd",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        },
        {
          icon: { class: "iconfont iconshouye21", style: "color:#00C897" },
          name: "即时评教",
          path: "/teacher/evaluateOnTime",
          code: "js_jspj"
        },
        {
          name: "全校课表",
          path: "/classTable/indexqx",
          code: "js_qxkb",
          icon: { class: "iconfont iconshouye17", style: "color:#FF8282" }
        },
        {
          name: "课程成绩单导出",
          path: "/classTable/indexkccjd",
          code: "js_kccjddc",
          icon: { class: "iconfont iconshouye17", style: "color:#FF8282" }
        },
        {
          name: "课堂评价查看",
          path: "/teacher/tea_ktpj",
          url: "ktpjck",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        },
        {
          name: "常见问题解决方案",
          path: "/teacher/cjwt",
          url: "jscjwtjjjfa",
          icon: require("../../../assets/images/wtjjfa.png")
        },
        {
          name: "学生成绩查看",
          path: "/xscjck/index",
          url: "xscjck",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "我的听课单",
          path: "/teacher/tkglIndex",
          url: "js_tkgl_wdtkd",
          icon: { class: "iconshouye21 iconfont", style: "color:#865FC1" }
        },
        {
          name: "我的教学效果",
          path: "/teacher/mytkglIndex",
          url: "js_tkgl_jxxg",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        },
        {
          name: "考试信息查询",
          path: "/ksxxcx/index",
          code: "xs_ksxxcx",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        }
      ],
      // 学生端
      studentList: [
        {
          name: "学分绩排名查询",
          path: "/student/xfjpmcx",
          url: "xs_xfjpmcx",
          icon: { class: "iconfont iconshouye8", style: "color:#00C897" }
        },
        // 武汉科技大学-学籍卡片
        {
          name: "学籍卡片",
          path: "/student/personInfo",
          url: "xs_xjkp",
          icon: { class: "iconfont iconshouye2", style: "color:#FF8080" }
        },
        // 武汉科技大学-实验预约管理
        {
          name: "实验预约管理",
          path: "/student/syyygl",
          url: "xs_syyygl",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        // 重庆电子-毕业标准
        {
          name: "毕业标准",
          path: "/student/bybz",
          url: "xs_bybz",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8282" }
        },
        {
          name: "全校课表",
          path: "/classTable/indexqx",
          code: "xs_qxkb",
          icon: { class: "iconfont iconshouye17", style: "color:#FF8282" }
        },
        {
          name: "培养方案完成情况",
          path: "/pyfawcqk/index",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "学业进度查看",
          path: "/xyjdck/index",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "学籍异动申请",
          path: "/xjydsq/index",
          url: "xjydsq",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "学生信息修改申请",
          path: "/xsxxxgsq/index",
          url: "grxxxg",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/byxxhd/index",
          url: "xs_byxxhd",
          icon: { class: "iconfont iconshouye9", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/jhrxxcj/index",
          url: "xs_jhrxxcj",
          icon: { class: "iconfont iconshouye6", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/plhksq/index",
          url: "xs_plhk",
          icon: { class: "iconfont iconshouye9", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/fyApply/index",
          url: "xs_cjfhsq",
          icon: { class: "iconshouye2 iconfont", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/holiday/index",
          url: "xs_qj",
          icon: { class: "iconshouye2 iconfont", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/freeApply/index",
          url: "xs_mtsq",
          icon: { class: "iconshouye25 iconfont", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/selectApply/index",
          url: "xs_cjsq",
          icon: { class: "iconshouye15 iconfont", style: "color:#5E73FF" }
        },
        {
          name: "",
          path: "/sxChange/index",
          url: "xs_sxyd",
          icon: { class: "iconfont iconshouye1", style: "color:#5E73FF" }
        },
        {
          name: "",
          path: "/sxAlone/index",
          url: "xs_ddsxsq",
          icon: { class: "iconfont iconshouye9", style: "color:#00C998" }
        },
        {
          name: "",
          path: "/sxKq/index",
          url: "xs_sxkq",
          icon: { class: "iconfont iconshouye11", style: "color:#865FC1" }
        },
        {
          name: "",
          path: "/sxTask/index",
          url: "xs_sxrw",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/bk/xspj",
          url: "xspj_find",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "创新学分查看",
          path: "/cxxf/index",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "学业完成情况",
          path: "/xywcqk/index?title=学业完成情况",
          icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        },
        {
          name: "辅修学业完成情况",
          path: "/xywcqk/index?title=辅修学业完成情况",
          icon: { class: "iconshouye15 iconfont", style: "color:#5E73FF" }
        },
        {
          name: "学分完成情况",
          path: "/nod?title=学分完成情况",
          url: "xs_xfwcqk",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "学分完成情况",
          path: "/student/xfwcqk_whkjdx/kcxdmx",
          url: "xs_xfwcqk_whkjdx",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "毕业结论查看",
          path: "/student/byjlck_whkjdx",
          url: "xs_byjlck_whkjdx",
          icon: { class: "iconfont iconshouye13", style: "color:#5E73FF" }
        },
        {
          name: "处分信息",
          path: "/nod?title=处分信息",
          icon: { class: "iconfont iconshouye7", style: "color:#00C998" }
        },
        {
          name: "教材使用评价",
          path: "/nod?title=教材使用评价",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "教学通知",
          path: "/nod?title=教学通知",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "教学制度",
          path: "/nod?title=教学制度",
          icon: { class: "iconfont iconshouye8", style: "color:#00C998" }
        },
        {
          name: "教学新闻",
          path: "/nod?title=教学新闻",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "我的课程",
          path: "/classTest/index?title=我的课程",
          icon: { class: "iconfont iconshouye18", style: "color:#FFC327" }
        },
        {
          name: "课程作业",
          path: "/classTest/index?title=课程作业",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "课程测验",
          path: "/classTest/index?title=课程测验",
          icon: { class: "iconshouye9 iconfont", style: "color:#00C897" }
        },
        {
          name: "课程讨论",
          path: "/classTest/index?title=课程讨论",
          icon: { class: "iconshouye21 iconfont", style: "color:#865FC1" }
        },
        {
          name: "学业进度",
          path: "/student/studyStatu",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "学生教室借用",
          path: "/roomBrrow/index",
          url: "xs_jsjy",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "",
          path: "/bindex",
          url: "xs_jsjy_hnkjdx",
          icon: { class: "iconfont iconshouye12", style: "color:#FF8080" }
        },
        {
          name: "学籍异动审核",
          path: "/teacher/bookIndex?id=4",
          url: "js_sh_xjyd",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "学籍异动",
          path: "/student/change",
          url: "xs_xjyd",
          icon: { class: "iconfont iconshouye2", style: "color:#5E73FF" }
        },
        {
          name: "学籍预警",
          path: "/student/warning",
          url: "xs_xjyj",
          icon: { class: "iconfont iconshouye15", style: "color:#FF8080" }
        },
        {
          name: "等级考试成绩 ",
          path: "/student/grades_score",
          url: "xs_cj_dj",
          icon: { class: "iconfont iconshouye22", style: "color:#FFC327" }
        },
        {
          name: "学期考试成绩",
          path: "/student/semester_Score",
          url: "xs_cj_xq",
          icon: { class: "iconfont iconshouye14", style: "color:#865FC1" }
        },
        {
          name: "成绩认定 ",
          path: "/student/score_Affirmation",
          url: "/student/achievementRecognition",
          icon: { class: "iconfont iconshouye21", style: "color:#865FC1" }
        },
        {
          name: "教学进度 ",
          path: "/student/syllabus",
          url: "xs_pyfa_jxjd",
          icon: { class: "iconfont iconshouye8", style: "color:#00C897" }
        },
        {
          name: "执行计划 ",
          path: "/student/executePlan",
          url: "xs_pyfa_zxjh",
          icon: { class: "iconfont iconshouye7", style: "color:#865FC1" }
        },
        {
          name: "培养方案明细 ",
          path: "/train/index",
          url: "xs_pyfa_mx",
          icon: { class: "iconfont iconshouye6", style: "color:#FF8080" }
        },
        {
          name: "期末考试安排",
          path: "/student/exam",
          icon: { class: "iconfont iconshouye16", style: "color:#FF8080" }
        },
        {
          name: "考试安排",
          path: "/student/exam",
          url: "xs_ksap",
          icon: { class: "iconfont iconshouye16", style: "color:#FF8080" }
        },
        {
          name: "选课",
          path: "/student/pickClass",
          url: "xs_xk",
          icon: { class: "iconfont iconxuanke", style: "color:#5E73FF" }
        },
        {
          name: "卓越计划",
          path: "/student/zyjhDkxz",
          url: "xs_zyjh",
          icon: { class: "iconfont iconshouye11", style: "color:#FF8080" }
        },
        {
          name: "课程表",
          path: "/new/Table",
          url: "xs_kcb",
          icon: { class: "iconfont iconshouye17", style: "color:#00C897" }
        },
        {
          name: "实验课表",
          path: "/SyKbTable",
          url: "xs_sykcb",
          icon: { class: "iconfont iconshouye17", style: "color:#FF8080" }
        },
        {
          name: "实践课程表",
          path: "/practiceSurfaces",
          url: "xs_sjkcb",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "教材",
          path: "/student/textbook",
          url: "xs_jc",
          icon: { class: "iconfont iconshouye11", style: "color:#FF8080" }
        },
        {
          name: "顶岗实习",
          path: "/internship/index",
          url: "xs_dgsx",
          icon: { class: "iconfont iconshixiqiandao", style: "color:#FF8080" }
        },
        {
          name: "课堂签到",
          path: "/student/attendanceAdd",
          url: "xs_kq",
          icon: { class: "iconfont iconketangqiandao", style: "color:#FFC327" }
        },
        {
          name: "等级考试报名",
          path: "/student/gradeExam",
          url: "xs_djksbm",
          icon: { class: "iconfont iconshouye1", style: "color:#FFC327" }
        },
        {
          name: "空闲教室",
          path: "/restRooms/index",
          url: "xs_kxjs",
          icon: { class: "iconfont iconshouye25", style: "color:#865FC1" }
        },
        {
          name: "辅导评测",
          path: "/student/counsellingteachEvaluate",
          icon: { class: "iconfont iconshouye1", style: "color:#00C897" }
        },
        {
          name: "缓考",
          path: "/student/delayedExam",
          url: "xs_hk",
          icon: { class: "iconfont iconshouye27", style: "color:#00C897" }
        },
        {
          name: "辅修报名",
          path: "/fxApply/index",
          url: "xs_fx",
          icon: { class: "iconfont iconshouye27", style: "color:#00C897" }
        },
        {
          name: "学生过程评价",
          path: "/processEvaluation/index",
          icon: { class: "iconfont iconshouye27", style: "color:#00C897" }
        },
        {
          name: "学生评价",
          path: "/studentEvaluation/index",
          icon: { class: "iconfont iconshouye27", style: "color:#00C897" }
        },
        {
          icon: { class: "iconfont iconshouye21", style: "color:#00C897" },
          name: "即时评教",
          path: "/student/evaluateOnTime",
          url: "xs_jspj"
        },
        {
          icon: { class: "iconfont iconshouye21", style: "color:#00C897" },
          name: "目标课程评价",
          path: "/student/evaluateGoal",
          url: "xs_mbkcpj"
        },
        {
          name: "实习签到",
          path: "/sign/location",
          url: "xs_sxqd",
          icon: { class: "iconfont iconshixiqiandao", style: "color:#5E73FF" }
        },
        {
          name: "班级课表",
          path: "/student/class-timetable-search",
          url: "xs_bjkb",
          icon: { class: "iconfont iconbanjikebiao", style: "color:#5E73FF" }
        },
        {
          name: "毕业状态查询",
          path: "/student/SelectGraduationStatus-index",
          url: "xs_byztcx",
          icon: {
            class: "iconfont iconbiyezhuangtaichaxun1",
            style: "color:#00C897"
          }
        },
        {
          name: "重修查询",
          path: "/student/searchRetest",
          icon: {
            class: "iconfont iconzhongxiubaoming",
            style: "color:#FF8080"
          }
        },
        {
          name: "重修报名",
          path: "/student/retouchList",
          url: "xs_cx",
          icon: {
            class: "iconfont iconzhongxiubaoming",
            style: "color:#FF8080"
          }
        },
        {
          name: "重修报名选课",
          path: "/student/cxCuarChoose",
          url: "xs_cxxk",
          icon: {
            class: "iconfont iconzhongxiubaoming",
            style: "color:#FF8080"
          }
        },
        {
          name: "补考报名",
          path: "/student/registRetest",
          icon: {
            class: "iconfont iconzhongxiubaoming",
            style: "color:#FF8080"
          }
        },
        {
          name: "补考查询",
          path: "/student/supplementExam",
          url: "xs_bk",
          icon: { class: "iconfont iconbukaochaxun", style: "color:#00C897" }
        },
        {
          name: "今日空闲教室",
          path: "/restClassroom",
          icon: { class: "iconfont iconshouye25", style: "color:#00C897" }
        },
        {
          name: "教学课堂反馈",
          path: "/teachAdvice/index",
          url: "xs_jxktfk",
          icon: {
            class: "iconfont iconketangjiaoxuefankui",
            style: "color:#00C897"
          }
        },
        {
          name: "通知",
          path: "/new/Msg",
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" }
        },
        {
          name: "成绩排名规则查看",
          path: "/student/gradeRules",
          url: "xs_cjpmgzcx",
          icon: { class: "iconfont iconshouye8", style: "color:#00C897" }
        },
        {
          icon: { class: "iconfont iconshouye19", style: "color:#FFC327" },
          name: "报到注册",
          path: "/student/registraTion",
          url: "xs_xjgl_bdzc"
        },
        {
          icon: { class: "iconfont iconshouye8", style: "color:#FF8080" },
          name: "教材订购",
          path: "/student/xsxkjcDg",
          url: "xs_jcdg"
        },
        {
          name: "各类课表查询",
          path: "/teacher/surfaAll",
          code: "js_kb_all",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "课表查询(教师)",
          path: "/teacher/surCuseAll_Find?findType=0&singcont=1",
          code: "xs_kb_all_skls",
          icon: { class: "iconfont iconshouye17", style: "color:#5E73FF" }
        },
        {
          name: "课表查询(班级)",
          path: "/teacher/surCuseAll_Find?findType=1&singcont=1",
          code: "xs_kb_all_skbj",
          icon: { class: "iconfont iconshouye17", style: "color:#FF8282" }
        },
        {
          name: "课表查询(课程)",
          path: "/teacher/surCuseAll_Find?findType=2&singcont=1",
          code: "xs_kb_all_skkc",
          icon: { class: "iconfont iconshouye17", style: "color:#EE7BFF" }
        },
        {
          name: "课表查询(教室)",
          path: "/teacher/surCuseAll_Find?findType=3&singcont=1",
          code: "xs_kb_all_skdd",
          icon: {
            class: "iconfont iconshouye17",
            style: "color:rgba(118,107,255,.7)"
          }
        },
        {
          name: "学籍信息查看",
          path: "/student/xs_xjxxck",
          url: "xs_xjxxck",
          icon: { class: "iconfont iconshouye7", style: "color:#FF8080" }
        },
        {
          name: "免修申请",
          path: "/student/exemptExam",
          url: "xs_cj_mxsq",
          icon: { class: "iconfont iconshouye27", style: "color:#FFC327" }
        },
        {
          name: "补考报名",
          url: "xs_cj_bkbm",
          path: "/student/registRetest",
          icon: {
            class: "iconfont iconzhongxiubaoming",
            style: "color:#FF8080"
          }
        },
        {
          name: "免修",
          path: "/student/exemptExam",
          url: "xs_exemptExam",
          icon: { class: "iconfont iconshouye27", style: "color:#FFC327" }
        },
        {
          name: "实习打卡",
          path: "/punchTheClock/index",
          icon: { class: "iconfont iconshouye7", style: "color:#FFC327" }
        },
        {
          name: "质量平台",
          path: "/zlpt",
          url: "xs_zlpt",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        },
        {
          name: "毕业设计",
          path: "/student/design",
          code: "xs_bysj",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "毕业学分要求",
          path: "/student/reqbyby",
          code: "xs_byxfyq",
          icon: { class: "iconfont iconshouye15", style: "color:#5E73FF" }
        },
        {
          name: "课堂评价",
          path: "/student/xs_ktpj",
          url: "ktpj",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        },
        {
          name: "常见问题解决方案",
          path: "/teacher/cjwt",
          url: "xscjwtjjjfa",
          icon: require("../../../assets/images/wtjjfa.png")
        },
        {
          name: "学生评教",
          path: "/student/evaluate",
          code: "xs_xspj",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        },
        {
          name: "体测成绩查看 ",
          path: "/student/physicalExamination",
          url: "xs_tccj",
          icon: { class: "iconfont iconshouye9", style: "color:#865FC1" }
        },
        {
          name: "补考报名",
          path: "/bkbm/index",
          url: "xs_bkbm",
          icon: { class: "iconfont iconshouye27", style: "color:#FFC327" }
        },
        {
          name: "成绩单申请",
          path: "/cjdsq/index",
          code: "xs_cjdsq",
          icon: { class: "iconfont iconshouye22", style: "color:#5E73FF" }
        },
        {
          name: "重修报名 ",
          path: "/cxbm/index",
          url: "xs_cxbm",
          icon: { class: "iconfont iconshouye9", style: "color:#865FC1" }
        }
      ],
      pathList: [],
      iconList: [
        {
          name: "我的查询",
          icon: "search"
        },
        {
          name: "我的申请",
          icon: "underway-o"
        },
        {
          name: "我的审核",
          icon: "warning-o"
        },
        {
          name: "我的课程",
          icon: "shop-o"
        },
        {
          name: "教学资讯",
          icon: "hot-o"
        },
        {
          name: "云课堂",
          icon: "tv-o"
        }
      ],
      schoolCode: "",
      isShowTips: false,
      msgText: ""
    };
  },
  methods: {
    backApp() {
      this.$router.go(-2);
    },
    iteming() {
      if (this.schoolCode == "10541") {
        document.getElementById("itemimg").style.backgroundImage =
          "url(../../../assets/images/1650521253(1).png)";
      } else {
        document.getElementById("itemimg").style.backgroundImage =
          "url(../../../../static/image/headT.png)";
      }
    },
    // 个性化的菜单
    personMenu() {
      if (sessionStorage.getItem("schoolCode") === "10079") {
        this.pathList.forEach(item => {
          if (item.name.trim() == "学业进度") {
            item.path = "/student/studyStatu1";
          }
        });
      }
      if (sessionStorage.getItem("schoolCode") === "10548") {
        this.pathList.forEach(item => {
          if (item.name.trim() == "教学评价") {
            item.path = "/evaluate1";
          }
        });
      }
      if (sessionStorage.getItem("schoolCode") === "13104") {
        this.pathList.forEach(item => {
          if (item.name.trim() == "重修报名") {
            item.path = "/cxApply/index";
          } else if (item.name.trim() == "补考报名") {
            item.path = "/bkApply/index";
          }
        });
      }
      if (sessionStorage.getItem("schoolCode") === "10298") {
        this.pathList.forEach(item => {
          if (item.name.trim() == "调课审核") {
            item.path = "/tksh/unpass";
          }
        });
      }
      if (sessionStorage.getItem("schoolCode") === "12609") {
        this.pathList.forEach(item => {
          if (item.name.trim() == "考试安排") {
            item.path = "/student/ksapcqdz";
          }
        });
      }
      if (sessionStorage.getItem("schoolCode") === "10488") {
        this.pathList.forEach(item => {
          if (item.name.trim() == "重修报名") {
            item.path = "/student/retouchList_10488";
          }
        });
      }
    },
    goMenu(i_item) {
      console.log(i_item, "@@@");
      if (this.schoolCode == "10013") {
        if (!!i_item.type && i_item.type == "a") {
          window.location.href = i_item.path;
        }
      }
      const arr = i_item.url.split("_");
      const val = arr[0] + "_" + arr[1];
      this.Change(val);

      if (i_item.url === "js_sh_tk" && this.schoolCode === "12711") {
        this.$router.push("/teacher/changeCoures/reviewList");
      } else if (i_item.url === "xs_xspj" && this.schoolCode === "10759") {
        this.$router.push("/student/evaluate_10759");
      } else {
        this.$router.push({
          path: i_item.path
        });
      }

      this.goCYGN(i_item);
    },
    async goCYGN(item) {
      const res = await Api.saveCommonMenu({
        menu: item.url
      });
    },
    async Change(val) {
      const params = {
        xx0101id: this.schoolCode,
        type: this.Identity == "2" ? "0" : "",
        isqy: "",
        key: "qzkj"
      };
      const res = await Api.getHomeMenuApi(params);
      if (res.data.length > 0) {
        res.data.forEach(item => {
          if (item.url == val) {
            this.i_id = item.i_id;
          }
        });
      }
      this.getAuth();
    },
    async getAuth() {
      const params = {
        I_ID: this.i_id
      };
      const res = await Api.getSubMenu(params);
      this.resetList = res.data;
      if (res.data.length > 0) {
        this.resetList.forEach(item => {
          this.pathList.forEach(list => {
            if (item.url == list.url) {
              item.path = list.path;
            }
          });
        });
      }
    },
    async getMenu() {
      this.$forceUpdate();
      const params = {
        xx0101id: sessionStorage.getItem("schoolCode"),
        key: "qzkj",
        is_home: "1",
        type: this.Identity == "2" ? "0" : ""
      };

      // 判断是否存储了菜单
      if (sessionStorage.getItem("menuSave") == "1") {
        this.menuList = JSON.parse(sessionStorage.getItem("homeMenuList"));
      } else {
        // 第一次获取菜单
        const res = await Api.getHomeMenuApi(params);
        // debugger
        this.menuList = res.data;
        sessionStorage.setItem("homeMenuList", JSON.stringify(res.data));
        sessionStorage.setItem("menuSave", "1");
      }
      if (!!this.menuList) {
        for (let i = 0; i < this.menuList.length; i++) {
          this.activeNames.push(this.menuList[i].i_id);
          let arr = [];
          this.menuList[i].child.forEach(item1 => {
            if (
              item1.url != "js_zsbm" &&
              item1.url != "js_bmqk" &&
              item1.url != "xs_bjkb"
            ) {
              arr.push(item1);
            }
          });
          this.menuList[i].child = arr;
        }
        this.menuList.forEach(item => {
          this.iconList.forEach(item3 => {
            if (item.name.trim() == item3.name.trim()) {
              item.icon = item3.icon;
            }
          });
          item.child.forEach(item1 => {
            this.pathList.forEach(item2 => {
              if (
                item1.name.trim() == item2.name.trim() ||
                (item2.url && item1.url.trim() == item2.url.trim())
              ) {
                item1.icon = item2.icon;
                item1.path = item2.path;

                if (
                  sessionStorage.getItem("schoolCode") == "10294" &&
                  item1.url === "xs_cj_xq"
                ) {
                  item1.path = "/student/semester_Score_10294";
                }
                if (
                  sessionStorage.getItem("schoolCode") == "10759" &&
                  item1.url === "js_jxpj_gzlcx"
                ) {
                  item1.path = "/workNum/index_shzdx";
                }
                if (
                  item1.url === "js_xscjcx" &&
                  sessionStorage.getItem("schoolCode") == "14475"
                ) {
                  item1.path = "/teacher/semester_Score";
                }
                if (
                  item1.url === "xs_sykcb" &&
                  sessionStorage.getItem("schoolCode") == "10488"
                ) {
                  item1.path = "/SyKbTable_whkj";
                }
              }
            });
          });
          if (item.name == "我的查询") {
            item.child.push({
              name: "教室VR全景",
              icon: {
                class: "iconfont iconshouye22",
                style: "color:#5E73FF"
              },
              type: "a",
              path:
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf1bb5361ed86c6ec&redirect_uri=https%3A%2F%2Fclassroom.bupt.edu.cn%2Ftsh%2Fwx_login%3Fhrf%3Dhttps%3A%2F%2Fclassroom.bupt.edu.cn%2F%23%2Ftsh%2Fservice%2Findexcumpus&response_type=code&scope=snsapi_b"
            });
          }
          if (sessionStorage.getItem("schoolCode") == "14475") {
            if (this.userType == "2") {
            } else if (this.userType == "1") {
            } else {
              if (item.name == "课表") {
                item.child.push({
                  name: "课表教学周历查询",
                  icon: {
                    class: "iconfont iconshouye15",
                    style: "color:#865FC1"
                  },
                  path: "/nod"
                });
              }
              if (item.name == "成绩管理") {
                item.child.push({
                  name: "成绩录入进度查看",
                  icon: {
                    class: "iconfont iconshouye19",
                    style: "color:#ffc327"
                  },
                  path: "/nod"
                });
              }
            }
          }
        });
      }
      if (sessionStorage.getItem("schoolCode") == "14475") {
        if (this.userType == "2") {
        } else if (this.userType == "1") {
          this.activeNames.push("cjfw");
          this.menuList.push({
            child: [
              {
                name: "成绩录入送审",
                icon: {
                  class: "iconfont iconshouye16",
                  style: "color:#865FC1"
                },
                url: "cjlrss",
                path: "/teacher/cjlrss"
              }
            ],
            i_id: "cjfw",
            name: "成绩服务"
          });
        } else {
          this.activeNames.push("xkfw");
          this.menuList.push({
            child: [
              {
                name: "学生选课名单查看",
                icon: {
                  class: "iconfont iconshouye3",
                  style: "color:#865FC1"
                },
                path: "/nod"
              },
              {
                name: "选课服务器状态监控",
                icon: {
                  class: "iconfont iconshouye4",
                  style: "color:#FF8282"
                },
                path: "/nod"
              }
            ],
            i_id: "xkfw",
            name: "选课服务"
          });
        }
      }
    },
    // 判断用户类型更改设置
    userConfig() {
      // console.log(this.userType);
      // this.userType = JSON.parse(sessionStorage.getItem("userInfo")).userType;
      this.userType = this.Identity;
      if (this.userType == "2") {
        this.pathList = this.studentList;
      }
      //  if (this.userType == "1")
      else {
        this.pathList = this.teacherList;
      }
      // 个性化的菜单
      this.personMenu();
      // 获取菜单
      this.getMenu();
    },
    async getIstl() {
      const res = await Api.getIsplttk();
      if (res.code == "1") {
        this.istk = res.data.istk;
      }
    },
    async getyjtz() {
      const res = await Api.getyjtz();
      if (res.code == "1") {
        this.ldandshsjObj = res.data;
      }
    },
    async initXywcqkyj(){
      const res = await Api.getxywcqkJs();
      if (res.code == "1") {
        this.isShowXyyj = res.data;
      }
    },
    async openDialog() {
      if (this.schoolCode === "10759") {
        const res = await Api.getWpjKc();
        console.log(res, "getWpjKc");
        if (res.code == "1") {
          var dpj = res.data.dpj;

          console.log(dpj, sj);
          if (dpj != 0) {
            this.msgText =
              "当前批次您还有" + dpj + "门次课程未评价，请尽快完成评价";
            this.isShowTips = true;

            if (res.data.sj !== "-1") {
              var sj = Number(res.data.sj);
              setTimeout(() => {
                this.isShowTips = false;
              }, sj * 1000);
            }
          }
        }
      }
    },
    onDialogConfirm() {
      this.$router.push("/student/evaluate_10759");
    }
  },
  created() {
    // 判断用户类型更改设置
    this.userConfig();
    this.schoolCode = sessionStorage.getItem("schoolCode");
    if (this.schoolCode == "10541" || this.schoolCode == "12981") {
      this.heardName = "";
    }
    if (this.schoolCode == "10054") {
      this.heardName = "首页";
    }
    if (this.schoolCode == "10848") {
      this.menuNub = 4;
    }
    if (this.schoolCode == "13954") {
      this.getIstl();
    }
    if (this.schoolCode == "43017") {
      this.getyjtz();
    }
    if (this.schoolCode == "13720") {
      this.initXywcqkyj();
    }
    this.openDialog();
  },
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f7f7f7");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  }
};
</script>
<style lang="less" scoped>
/deep/.my-dialog {
  padding: 1.25rem;
  box-sizing: border-box;
  box-shadow: 0px 1px 4px 0px rgba(160, 160, 160, 0.5);
  border-radius: 0.3125rem;
}
.msg-box {
  .msg-title {
    text-align: center;
    font-size: 1rem;
    color: #212f6e;
    letter-spacing: 0;
    font-weight: 600;
    margin-bottom: 1.25rem;
  }
  .msg-text {
    font-size: 1rem;
    color: #757da3;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    margin-bottom: 1.25rem;
  }
  .btn-bar {
    display: flex;
    justify-content: space-between;

    .btn {
      flex: 1;
      height: 2.75rem;
      background: #7469f8;
      font-size: 1rem;
      color: #ffffff;
      border-radius: 3px;
      text-align: center;
      line-height: 44px;
    }
    .plain.btn {
      background: #ecedfd;
      color: #7469f8;
      margin-right: 2.75rem;
    }
  }
}
.box {
  .box-title {
    white-space: nowrap;
    height: 28px;
    font-family: PingFangSC-SNaNpxibold;
    font-size: 20px;
    color: #272727;
    letter-spacing: 0;
    font-weight: bolder;
    position: absolute;
    top: 24px;
    left: 20px;

    i {
      background: url("../../../../static/img/back.png") no-repeat center;
      width: 30px;
      height: auto;
      background-size: 10px;
    }
  }
  .box-imgS {
    display: inline-flex;
    width: 100%;
    height: 110px;
    background: #8076fc;
    border-radius: 8px;
    margin-bottom: 10px;
    background-image: url("../../../../static/image/headT.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .boximg {
    display: inline-flex;
    width: 100%;
    height: 110px;
    background: #8076fc;
    margin-top: -34px;
    border-radius: 8px;
    margin-bottom: 10px;
    background-image: url("../../../assets/images/1650521253(1).png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .boximg3 {
    display: inline-flex;
    width: 100%;
    height: 110px;
    background: #8076fc;
    border-radius: 8px;
    margin-bottom: 10px;
    background-image: url("../../../../static/image/headT.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .box-imgT {
    display: inline-flex;
    width: 100%;
    height: 110px;
    background: #8076fc;
    border-radius: 8px;
    margin-bottom: 10px;
    background-image: url("../../../../static/image/headT.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .box-img {
    padding-left: 1.5rem;
    font-family: SourceHanSansCN-Medium;
    font-size: 22px;
    color: #ffffff;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.09);
    box-sizing: border-box;
  }
  .box-img > span {
    line-height: 110px;
  }
  .box-content,
  .van-collapse-item {
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    margin-bottom: 10px;
    .item-value {
      width: 100%;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 13px;
      color: #333333;
      letter-spacing: 0;
      text-align: center;
      line-height: 18px;
    }
    .name {
      // width: 40px;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      text-align: center;
      // margin-top: 10px;
    }
  }
}
</style>
<style lang="less" scoped>
.box {
  .box-content {
    .van-grid-item__content {
      background-color: transparent;
      justify-content: unset;
      padding: 13px 18px;
      .iconfont {
        font-size: 42px;
      }
    }
    .van-collapse-item__title--expanded::after {
      display: none;
    }
    .van-collapse-item__content {
      padding: 0;
    }
    .van-cell__title {
      width: 56px;
      height: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
    }
    .van-cell {
      padding: 12px 14px;
    }
    .van-cell,
    .van-collapse-item__content {
      border-radius: 8px !important;
    }
  }
  .my-Dialog {
    h3,
    p {
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #7d7e80;
      text-align: center;
      line-height: 20px;
      padding: 10px 0;
    }
    p {
      color: red;
    }
  }
}
.yjtittle {
  padding-left: 10px;
  padding-bottom: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
}
.yjcontext {
  padding-left: 20px;
  padding-right: 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/Home/Home.vue